var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmallHisto(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(.5)",
    fill: "#2175D9",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 10a1 1 0 00-1-1h-4V7a1 1 0 011-1h8a1 1 0 011 1v13a1 1 0 01-1 1h-5a1 1 0 001-1v-1h3V8h-6v.993h2a1 1 0 011 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 19v-8H9v2H7v-3a1 1 0 011-1h8a1 1 0 011 1v10a1 1 0 01-1 1H9a1 1 0 001-1v-1h5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 13,
    width: 8,
    height: 8,
    rx: 1
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNSAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKC41KSIgZmlsbD0iIzIxNzVEOSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8cGF0aCBkPSJNMTcgMTBhMSAxIDAgMCAwLTEtMWgtNFY3YTEgMSAwIDAgMSAxLTFoOGExIDEgMCAwIDEgMSAxdjEzYTEgMSAwIDAgMS0xIDFoLTVhMSAxIDAgMCAwIDEtMXYtMWgzVjhoLTZ2Ljk5M2gyYTEgMSAwIDAgMSAxIDF6Ii8+CiAgICAgICAgPHBhdGggZD0iTTE1IDE5di04SDl2Mkg3di0zYTEgMSAwIDAgMSAxLTFoOGExIDEgMCAwIDEgMSAxdjEwYTEgMSAwIDAgMS0xIDFIOWExIDEgMCAwIDAgMS0xdi0xaDV6Ii8+CiAgICAgICAgPHJlY3QgeD0iMiIgeT0iMTMiIHdpZHRoPSI4IiBoZWlnaHQ9IjgiIHJ4PSIxIi8+CiAgICA8L2c+Cjwvc3ZnPgo=";
export { SvgSmallHisto as ReactComponent };